import React, { useMemo } from 'react';

const Snowfall = () => {
  const snowflakes = useMemo(() => {
    return Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      animationDuration: `${Math.random() * 10 + 5}s`,
      animationDelay: `${Math.random() * 5}s`,
      fontSize: `${Math.random() * 10 + 8}px`,
      opacity: Math.random() * 0.6 + 0.4
    }));
  }, []);

  const flakeCharacters = ['❄', '❅', '❆', '✧', '✦'];

  return (
    <div className="snowfall">
      {snowflakes.map(flake => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: flake.left,
            animationDuration: flake.animationDuration,
            animationDelay: flake.animationDelay,
            fontSize: flake.fontSize,
            opacity: flake.opacity
          }}
        >
          {flakeCharacters[Math.floor(Math.random() * flakeCharacters.length)]}
        </div>
      ))}
    </div>
  );
};

export default Snowfall;
